import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AmazonMWSObjectDataset } from 'app/model/dataset/amazon-mws.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'AmazonMWSSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AmazonMWSObjectDataset) }
})
export class AmazonMWSCopySource extends TabularCopySource {
}
